// Mock data for Arranque Express BCN - Catalan version
export const mockDataCat = {
  // Contact info
  contacts: {
    whatsapp: "+34613076099",
    phone: "+34 XXX XXX XXX",
    email: "info@arranqueexpressbcn.com"
  },
  
  // Pricing
  pricing: {
    day: {
      price: 69,
      hours: "8:00 - 22:00",
      days: "Dilluns a Divendres"
    },
    night: {
      price: 89,
      hours: "22:00 - 8:00",
      days: "Nits"
    },
    weekend: {
      price: 99,
      hours: "Tot el dia",
      days: "Dissabtes i Diumenges"
    }
  },
  
  // Payment methods
  paymentMethods: [
    { name: "Bizum", icon: "smartphone" },
    { name: "Targeta", icon: "credit-card" },
    { name: "Efectiu", icon: "banknote" }
  ],
  
  // Service areas
  zones: [
    { name: "Barcelona Ciutat", supplement: 0, description: "Tots els barris de Barcelona" },
    { name: "Àrea Metropolitana", supplement: 0, description: "L'Hospitalet, Badalona, Santa Coloma..." },
    { name: "Aeroport El Prat", supplement: 25, description: "Terminals T1 i T2, pàrkings" }
  ],
  
  // How it works steps
  howItWorks: [
    {
      step: 1,
      title: "Truca'ns o escriu-nos",
      description: "Contacta per WhatsApp o telèfon. Et responem a l'instant."
    },
    {
      step: 2,
      title: "Arribo ràpid",
      description: "Arribem avui mateix amb equipament professional."
    },
    {
      step: 3,
      title: "Arrencada exitosa",
      description: "Arranquem el teu cotxe. Només pagues si funciona."
    }
  ],
  
  // Services list
  services: [
    {
      title: "Arrencada 12V",
      description: "Arrencada professional amb bateria portàtil",
      icon: "zap"
    },
    {
      title: "Servei 24/7",
      description: "Disponibles tots els dies de l'any",
      icon: "clock"
    },
    {
      title: "A domicili",
      description: "Anem on siguis a Barcelona",
      icon: "map-pin"
    },
    {
      title: "Preu fix",
      description: "Sense sorpreses ni costos ocults",
      icon: "euro"
    }
  ],
  
  // FAQ
  faq: [
    {
      question: "Quant trigeu a arribar?",
      answer: "Normalment arribem en menys d'1 hora. L'horari exacte depèn del trànsit i la ubicació, però sempre t'informarem del temps estimat d'arribada."
    },
    {
      question: "Quines formes de pagament accepteu?",
      answer: "Acceptem Bizum, targeta de crèdit/dèbit i efectiu. El pagament es fa només si aconseguim arrencar el teu vehicle."
    },
    {
      question: "Treballeu els caps de setmana?",
      answer: "Sí, oferim servei tots els dies de l'any, inclosos caps de setmana i festius. Els preus poden variar segons l'horari."
    },
    {
      question: "Inclou el preu el desplaçament?",
      answer: "Sí, el preu inclou el desplaçament dins de la zona estàndard de Barcelona. Per zones més allunyades pot haver-hi un suplement per distància."
    },
    {
      question: "Què passa si no aconseguiu arrencar el cotxe?",
      answer: "Si no aconseguim arrencar el teu vehicle després d'intentar-ho amb els nostres equips professionals, no cobraràs res. El nostre servei és 100% gratuït si no té èxit."
    },
    {
      question: "Funciona amb cotxes elèctrics?",
      answer: "Per cotxes elèctrics o híbrids, només podem actuar sobre la bateria auxiliar de 12V, no sobre els sistemes d'alt voltatge per motius de seguretat."
    }
  ],
  
  // Company info
  company: {
    name: "ArrancaYa BCN",
    tagline: "Arranquem el teu cotxe a Barcelona",
    slogan: "Més ràpid que la teva assegurança, més econòmic que una grua",
    description: "Servei professional d'arrencada de vehicles a domicili a Barcelona",
    logo: "/images/logo.png",
    heroImage: "/images/hero-arranque.jpg",
    keyPoints: [
      "Arranquem tot tipus de cotxe, arribem amb bateria portàtil professional i només pagues si el teu cotxe arrenca",
      "No necessites grua ni esperar hores: venim en scooter amb una bateria portàtil professional i arranquem el teu cotxe en minuts",
      "No canviem la bateria, simplement arranquem el teu vehicle",
      "100% reemborsament si no aconseguim arrencar-lo",
      "Desplaçament gratuït dins la zona de cobertura"
    ],
    heroTitle: "El teu cotxe s'ha quedat sense bateria?",
    heroSlogan: "T'ho arranquem avui mateix",
    heroPoints: [
      "Servei express a Barcelona",
      "Preu fix 69€* amb IVA",
      "Només pagues si el teu cotxe arrenca"
    ],
    whatsappCTA: "Sol·licitar Arrencada",
    callCTA: "Truca ara"
  },
  
  // Car brands
  carBrands: [
    "Audi", "BMW", "Mercedes", "Volkswagen", "Ford", "Renault", "Peugeot", 
    "Citroën", "Opel", "Nissan", "Toyota", "Hyundai", "Kia", "Seat", 
    "Skoda", "Fiat", "Alfa Romeo", "Volvo", "Mazda", "Honda"
  ],

  // Barcelona images
  barcelonaImages: [
    "https://images.unsplash.com/photo-1583422409516-2895a77efded?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzR8MHwxfHNlYXJjaHwxfHxCYXJjZWxvbmElMjBjaXR5fGVufDB8fHx8MTc1Nzg1MjI1Mnww&ixlib=rb-4.1.0&q=85",
    "https://images.pexels.com/photos/1388030/pexels-photo-1388030.jpeg",
    "https://images.unsplash.com/photo-1731266955612-67dab3692dfc?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2MzR8MHwxfHNlYXJjaHwzfHxCYXJjZWxvbmElMjBzdHJlZXRzfGVufDB8fHx8MTc1Nzg1MjI2MHww&ixlib=rb-4.1.0&q=85"
  ]
};